export const test = {
    PRE_SIGNED_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-stg.pcx-test.nike.com/pcx/dla/v1/operations?'
}

export const local = {
    PRE_SIGNED_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/operations?'
}
export const sandbox1 = {
    PRE_SIGNED_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-sandbox.pcx-test.nike.com/pcx/dla/v1/operations?'
}

export const sandbox = {
    PRE_SIGNED_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/operations?'
}


export const sandbox2 = {
    PRE_SIGNED_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-perf.pcx-test.nike.com/pcx/dla/v1/operations?'
}

export const dev = {
    PRE_SIGNED_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL: 'https://dataloader-api-dev.pcx-test.nike.com/pcx/dla/v1/operations?'
}


export const prod = {
    PRE_SIGNED_URL: 'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v1/getPresigned',
    NOTIFY_OPERATION_URL: 'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v1/operations',
    FILEDOWNLOAD_OPERATION_URL : 'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v1/files/',
    STATUS_OPERATION_URL:'https://dataloader-api.pcx-prod.nike.com/pcx/dla/v1/operations?'

}